import { useState } from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { Collapse } from '@shared/components/collapse/collapse'
import classes from '@/components/speci/speci-sidebar-table.module.css'

interface LineNumberTableProps {
  heading?: string
}

export const LineNumberTable = ({ heading = 'Zentera Line Numbers' }: LineNumberTableProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Collapse
      sectionHeading={heading}
      buttonLabel='table'
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
    >
      <Stack gap='xs'>
        <Text size='sm'>
          The Line Number is a 5 digit number. The first two digits relate to the Season the wool
          was received in, the last three digits relate to the breed and age class.
        </Text>
        <Table.ScrollContainer minWidth={400}>
          <div className={classes.tableContainer}>
            <Table withColumnBorders>
              <Table.Tbody>
                <Table.Tr>
                  <Table.Td fw={700} rowSpan={3} style={{ textAlign: 'center' }}>
                    Merinos
                  </Table.Td>
                  <Table.Td>100 - 199</Table.Td>
                  <Table.Td>EWES</Table.Td>
                  <Table.Td>Bins 199</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td>200 - 299</Table.Td>
                  <Table.Td>HOGGETS</Table.Td>
                  <Table.Td>Bins 299</Table.Td>
                </Table.Tr>
                <Table.Tr className={classes.rowEmphasis}>
                  <Table.Td>300 - 399</Table.Td>
                  <Table.Td>WETHERS</Table.Td>
                  <Table.Td>Bins 399</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td fw={700} rowSpan={3} style={{ textAlign: 'center' }}>
                    1/4 Breds
                  </Table.Td>
                  <Table.Td>400 - 499</Table.Td>
                  <Table.Td>EWES</Table.Td>
                  <Table.Td>Bins 499</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td>500 - 569</Table.Td>
                  <Table.Td>HOGGETS</Table.Td>
                  <Table.Td>Bins 569</Table.Td>
                </Table.Tr>
                <Table.Tr className={classes.rowEmphasis}>
                  <Table.Td>570 - 599</Table.Td>
                  <Table.Td>LAMBS</Table.Td>
                  <Table.Td>Bins 599</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td fw={700} rowSpan={3} style={{ textAlign: 'center' }}>
                    1/2 Breds
                  </Table.Td>
                  <Table.Td>600 - 699</Table.Td>
                  <Table.Td>EWES</Table.Td>
                  <Table.Td>Bins 699</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td>700 - 769</Table.Td>
                  <Table.Td>HOGGETS</Table.Td>
                  <Table.Td>Bins 769</Table.Td>
                </Table.Tr>
                <Table.Tr className={classes.rowEmphasis}>
                  <Table.Td>770 - 799</Table.Td>
                  <Table.Td>LAMBS</Table.Td>
                  <Table.Td>Bins 799</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td fw={700} rowSpan={3} style={{ textAlign: 'center' }}>
                    Xbreds
                  </Table.Td>
                  <Table.Td>800 - 899</Table.Td>
                  <Table.Td>EWES</Table.Td>
                  <Table.Td>Bins 899</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td>900 - 969</Table.Td>
                  <Table.Td>HOGGETS</Table.Td>
                  <Table.Td>Bins 969</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td>970 - 999</Table.Td>
                  <Table.Td>LAMBS</Table.Td>
                  <Table.Td>Bins 999</Table.Td>
                </Table.Tr>
              </Table.Tbody>
            </Table>
          </div>
        </Table.ScrollContainer>
      </Stack>
    </Collapse>
  )
}
